module.exports = "/images/squarespace.png?14c6d2e92e10ccf04a653f70429bc9df";